import React, { FunctionComponent, useMemo } from 'react'
import styles from './ObjectLineDesktop.module.sass'
import { useRootDispatch, useRootSelector } from '../../../../../../utils/hooks'
import Button from '../../../../../controls/Button/Button'
import { projectListActions } from '../../../../../../redux/pages/project-list'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { urlWithParams } from '../../../../../../http/utils'
import { ROUTES } from '../../../../../../http/routes'
import UserPanel from '../../../../../data-components/elements/UserElement/UserElement'
import TaskLine from '../../ProjectFilters/TaskLine/TaskLine'
import { objectSelector, parentsSelector } from '../../../../../../utils/selectors'
import { RequestStatus } from '../../../../../../responses/response'
import ProgressBar from '../../../../../etc/ProgressBar/ProgressBar'
import ObjectName from '../../../../../etc/ObjectName/ObjectName'
import DesignStatusElement from '../../../../../data-components/elements/DesignStatusElement/DesignStatusElement'
import FolderIcon from 'files/folder.svg'
import FolderOpenIcon from 'files/folder-open.svg'
import SideMark from '../../../../../etc/SideMark/SideMark'
import { Classes } from '../../../../../../styles'
import { ID } from '../../../../../../types/UtilityTypes'
import { ObjectStatus, objectToColor } from '../../../../../../responses/objects'

interface ObjectLineProps {
    objectId: ID,
}

const ObjectLineDesktop: FunctionComponent<ObjectLineProps> = props => {
    const dispatch = useRootDispatch()
    const open = useRootSelector(state => state.pages.projectList.openObjects[props.objectId])
    const parents = useRootSelector(parentsSelector(props.objectId))
    const object = useRootSelector(objectSelector(props.objectId))
    const status = useRootSelector(state => state.pages.projectList.objectStatuses[props.objectId])
    const url = useMemo(() => {
        return urlWithParams({
            projectId: object?.project_id,
            objectId: props.objectId
        })(ROUTES.OBJECT)
    }, [object?.project_id, props.objectId])

    if (!object) {
        return <></>
    }

    return <>
        <div className={clsx(styles.object, {[styles.open]: open})}>
            <div>
                <SideMark color={objectToColor(object)}/>
                {
                    object.tasks_count > 0 &&
                        <Button
                            active={open}
                            onClick={() => dispatch(projectListActions.toggleObject(object.id))}
                        >
                            {open ? <FolderOpenIcon/> : <FolderIcon/>}
                        </Button>
                }
            </div>
            <Link to={url}>
                <ObjectName object={object}/>
            </Link>
            <Link to={url}>
                {object.curator && <UserPanel
                    user={{
                        ...object.curator,
                        description: 'Куратор',
                    }}
                />}
            </Link>
            <Link className={Classes.justifyCenter} to={url}>
                {
                    object.status_id !== ObjectStatus.OPENED && <>
                        <DesignStatusElement tooltip status={object.design_status} type={'design'}/>
                        <DesignStatusElement tooltip status={object.production_status} type={'production'}/>
                    </>
                }
            </Link>
        </div>
        {
            open && status === RequestStatus.FETCHING && <ProgressBar className={styles.progress}/>
        }
        {
            open && parents.map((parentId, index) => <TaskLine
                key={parentId}
                parentId={parentId}
                index={index}
            />)
        }
    </>
}

export default ObjectLineDesktop